import { HttpClient, provideHttpClient, withFetch } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideTranslateService, TranslateDirective, TranslateLoader, TranslatePipe } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ClipboardModule } from 'ngx-clipboard';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { ModalModule } from 'ngx-bootstrap/modal';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { BannerComponent } from './components/banner/banner.component';
import { FeatureComponent } from './components/feature/feature.component';
import { FooterComponent } from './components/footer/footer.component';
import { GalleryComponent } from './components/gallery/gallery.component';
import { GetInTouchComponent } from './components/get-in-touch/get-in-touch.component';
import { HeaderComponent } from './components/header/header.component';
import { HomeComponent } from './components/home/home.component';
import { LanguageComponent } from './components/language/language.component';
import { OurJourneyComponent } from './components/our-journey/our-journey.component';
import { OurProgramsComponent } from './components/our-programs/our-programs.component';
import { ScrollerComponent } from './components/scroller/scroller.component';
import { VoicesComponent } from './components/voices/voices.component';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [
    AppComponent,
    AboutUsComponent,
    BannerComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    GalleryComponent,
    GetInTouchComponent,
    LanguageComponent,
    OurJourneyComponent,
    OurProgramsComponent,
    ScrollerComponent,
    VoicesComponent,
    FeatureComponent,
  ],
  imports: [
    // Angular Core
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,

    // Third-party (NGX & others) sorted alphabetically
    AccordionModule,
    AngularSvgIconModule.forRoot(),
    BsDropdownModule.forRoot(),
    CarouselModule,
    ClipboardModule,
    ModalModule.forRoot(),
    PopoverModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 4000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
      disableTimeOut: false,
      progressBar: true,
      progressAnimation: 'decreasing',
      maxOpened: 1,
    }),
    TranslateDirective,
    TranslatePipe,

    // App Modules (Routing must be last if it has wildcard routes)
    SharedModule,
    AppRoutingModule,
  ],
  providers: [
    provideHttpClient(withFetch()),
    provideTranslateService(),
    provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
    provideClientHydration(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
